export default __webpack_public_path__ + "static/media/A5_printing_rules_mm.693be5f3.pdf";